import React, { useRef } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import HamburgerCloseIcon from './images/close-green.png'
import { useDiscoveryAzureUser } from './hooks'

export default function StationSignOutBox({ logoutCallback, toggleDrawer }) {
  const discoveryUser = useDiscoveryAzureUser()
  const [t] = useTranslation()
  const emailInput = useRef()

  const discoverysSentToCSS = css`
    display: inline-block;
    color: #4d4e4b;
    font-family: museo;
    font-size: 24px;
    margin-top: 25px;
  `

  const discoverMoreCSS = css`
    display: inline-block;
    color: #999999;
    font-family: Verdana;
    font-size: 20px;
    margin-top: 25px;
    display: block;
  `

  const emailSentToContainerCSS = css`
    margin-top: 27px;
    padding-left: 0;
  `
  const emailInputLabelCSS = css`
    font-family: museo;
    height: 50px;
    color: #fff;
  `
  const emailInputCSS = css`
    background-color: #8dbc49;
    font-family: museo;
    font-size: 24px;
    border: none;
    padding: 9px;
    color: #fff;
    width: 100%;
    ::placeholder {
      color: #fff;
      opacity: 1;
    }
  `
  const signOutCSS = css`
    display: block;
    color: #979797;
    font-family: Verdana;
    font-size: 20px;
    margin-left: 10px;
    margin-top: 9px;
    float: left;
  `
  const outerContainerCSS = css`
    background-color: #fdfdfd;
    padding: 30px;
    boxsizing: border-box;
    width: 450px;
  `

  return (
    <>
      <div css={outerContainerCSS}>
        <div
          tabIndex={0}
          role="button"
          onKeyPress={() => toggleDrawer('right', true)}
          onClick={() => toggleDrawer('right', true)}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={() => {
              logoutCallback(emailInput.current.value)
            }}
            onKeyPress={() => {
              logoutCallback(emailInput.current.value)
            }}
          >
            <img src={HamburgerCloseIcon} alt="Nav" css={{ width: '44px', float: 'left', outline: 'none' }} />
            <span css={signOutCSS}>{t('station.sign-out', 'Sign Out')}</span>
          </div>
        </div>
        <span css={discoverysSentToCSS}>
          {t('station.discoveries-sent-to', 'Your discoveries from today will be sent to:')}
        </span>
        <div css={emailSentToContainerCSS}>
          <label css={emailInputLabelCSS}>
            <input
              id="email-input"
              type="email"
              ref={emailInput}
              css={emailInputCSS}
              placeholder={t('station.email-address', 'Email Address')}
              defaultValue={discoveryUser.email}
            />
          </label>
          <span css={discoverMoreCSS}>{t('station.discover-more', 'Discover more at FamilySearch.org333.')}</span>
        </div>
      </div>
    </>
  )
}

StationSignOutBox.propTypes = {
  logoutCallback: func,
  toggleDrawer: func,
}
